import { BASE_URL } from '../endpoints'
import { del, get, post } from '../https'

export const getWhistleBlowing = (
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/whistle-blowings/invitations?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const getSingleWistleBlowingById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/invitations/${id}`)
}
export const addWistleBlowingComments = (
  data: {
    comment: string
  },
  id: string
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings/${id}/comments`, data, null)
}

export const deleteWhistleBlowing = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(
    `${BASE_URL}/whistle-blowings/invitations/${id}/whistle-blowing`,
    null
  )
}
